import { useEffect } from "react";

/**
 * Client-facing pages (invoice, proposal, portal, forms) read at 16px; the
 * CRM's default text is 14px. Sets it on <body> so dialogs and menus that
 * render outside the page follow it too.
 */
export const usePublicReadingText = () => {
  useEffect(() => {
    document.body.classList.add("public-reading");
    return () => document.body.classList.remove("public-reading");
  }, []);
};
